export const dynamic = 'force-dynamic';
export { LastWillPDF } from './LastWillPDF';
export { WillCertificatePDF } from './WillCertificatePDF';
export { VideoCertificatePDF } from './VideoCertificatePDF';
